import React, { useState } from "react";

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { Row, Col } from 'react-bootstrap';
import AITestContext from '../../../contexts/AITestContext'
import StatusContext from '../../../contexts/StatusContext';
import AuthContext from "../../../contexts/AuthContext";
import SchoolYearCourses from './SchoolYearCourses'
import { PushButton } from '../pushbutton/PushButton';

import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import {StripePaymentForm} from './StripePaymentForm'

import { config } from "../../../config";

// IMPORTANT:
// Make sure this variable actually exists in your .env file.
//
// For Create React App:
// REACT_APP_STRIPE_PUBLISHABLE_KEY=pk_test_....
//
// For Vite it would be:
// import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY
//
const stripePromise = loadStripe(
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY
);



export const RadioButtonsSchoolYear = ({scrollref}) => {

  const [selectedschoolyear, setSelectedSchoolYear] = useState("")
  const [showPayment, setShowPayment] = useState(false);
  const [clientSecret, setClientSecret] = useState(null);
  const [paymentLoading, setPaymentLoading] = useState(false);
  
  // --------------------------------------------------
  // STATUS CONTEXT
  // --------------------------------------------------
  
  const {
        changeTestLanguage,
        setShowLoginDialog,
    } = React.useContext(StatusContext);
  
  // --------------------------------------------------
  // AUTH CONTEXT
  // --------------------------------------------------
    
   const {
        currentUser,
        checkCurrentUser
    } = React.useContext(AuthContext);

  // --------------------------------------------------
  // AI TEST CONTEXT
  // --------------------------------------------------
  const {
    setSchoolYear,
    schoolyear,
    saveTestSchoolYear,
    onChangeSchoolYear,
    showschoolyearcourses,
    universityindex,
    universities,
    collegeindex,
    isSchoolYearTestsBought,
    saveBoughtSchoolYearTests,
    schoolyeartestsprice
   
    } = React.useContext(AITestContext);

   

  const handleChange = (event) => {
    console.log('handleChange:', event.target.value)
    setSchoolYear(event.target.value)
    saveTestSchoolYear(event.target.value)
    onChangeSchoolYear(event.target.value)
  };

  
// --------------------------------------------------
  // BUY COURSES
  // --------------------------------------------------

  const handleBuy = async () => {
   
    console.log("handleBuy School Year courses:");

     if (checkCurrentUser() === false)
        {
            setShowLoginDialog(true)
            return;
        }
  
    // ------------------------------------------------
    // Check that context data exists
    // ------------------------------------------------

    if (!universities ||
        universities.length === 0 ||
        universityindex == null ||
        collegeindex == null) {

      console.error(
        "University/college information is missing"
      );

      return;
    }

    const university =
      universities[universityindex].university;


    const schoolname =
      universities[universityindex]
        .college[collegeindex]
        .name;

    const schoolyear =
      showschoolyearcourses;

    setSelectedSchoolYear(schoolyear)

    // ------------------------------------------------
    // Show payment area
    // ------------------------------------------------

    setPaymentLoading(true);

    setShowPayment(true);

     try {
    
          // ------------------------------------------------
          // Create PaymentIntent on your SERVER
          // ------------------------------------------------
    
          const response = await fetch(
    
            config.url.API_URL +
            "/deda_ai_api/pay/buycollegeschoolyeartestsintent",
    
            {
              method: "POST",
    
              headers: {
                "Content-Type": "application/json"
              },
    
              body: JSON.stringify({
    
                university: university,
    
                schoolname: schoolname,
    
                schoolyear: schoolyear,
    
                user: currentUser,
    
                // Price is set on the server side
              
               
              })
            }
          );
    
    
          const data = await response.json();
    
    
          console.log(
            "buytestintent response:",
            data
          );
    
    
          if (!response.ok) {
    
            throw new Error(
              data.message ||
              "Unable to create payment"
            );
          }
    
    
          if (!data.clientSecret) {
    
            throw new Error(
              "Server did not return clientSecret"
            );
          }
    
    
          // ------------------------------------------------
          // Stripe PaymentIntent client secret
          // ------------------------------------------------
    
          setClientSecret(
            data.clientSecret
          );
    
    
        } catch (error) {
    
          console.error(
            "Payment initialization error:",
            error
          );
    
          console.log("It is OK")
          setShowPayment(false);
    
          //setBuyingItem(null);
    
          setClientSecret(null);
    
    
        } finally {
    
          setPaymentLoading(false);
    
        }


  }

  // --------------------------------------------------
  // CANCEL PAYMENT
  // --------------------------------------------------

  const handlePaymentCancel = () => {

    setShowPayment(false);
    setClientSecret(null);
  };

  // --------------------------------------------------
  // PAYMENT SUCCESS
  // --------------------------------------------------

  const handlePaymentSuccess = () => {

    console.log(
      "Stripe payment completed: Bought School Year Tests"
    );

    saveBoughtSchoolYearTests()

    setShowPayment(false);

    setClientSecret(null);

    //setBuyingItem(null);

  };

// --------------------------------------------------
  // RENDER
  // --------------------------------------------------

  return (
    <FormControl >
     
      {/*<FormLabel id="demo-controlled-radio-buttons-group">{changeLanguage('status', 'responsetype')}:</FormLabel>*/}
      <RadioGroup
        row
        aria-labelledby="demo-controlled-radio-buttons-group"
        name="controlled-radio-buttons-group"
        value={schoolyear}
        onChange={handleChange}
      >
        <div >
        <Row>
          <Col>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
           
            <FormControlLabel  sx={{
                          '& .MuiSvgIcon-root': {
                          fontSize: 20,
                          }, 
                        '& .MuiFormControlLabel-label': {
                          fontWeight: 'bold',
                          }}}
                          value="First year"  control={<Radio size ="small"/>} label={changeTestLanguage("aitest", 'firstyear')}/>
          
         
            {
              showschoolyearcourses === 'First year' && !isSchoolYearTestsBought() &&
               <PushButton onClick={handleBuy} label =  {changeTestLanguage('aitest', 'buyalltests')} colorback = {'green'}/>                           
            }
          
          </div>
        </Col>
      </Row>

      {
        selectedschoolyear === 'First year' &&
      <div>
       {/* ====================================== */}
            {/* PAYMENT LOADING                         */}
            {/* ====================================== */}

            {showPayment &&
              //buyingItem === item &&
              paymentLoading && (

                <div
                  onClick={(e) =>
                    e.stopPropagation()
                  }

                  style={{
                    padding: "15px",
                    marginTop: "10px",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "8px"
                  }}
                >

                  Creating payment...

                </div>

              )}

               {/* ====================================== */}
                          {/* STRIPE PAYMENT FORM                    */}
                          {/* ====================================== */}
              
                          {showPayment &&
                            //buyingItem === item &&
                            clientSecret && (
              
                              <div
              
                                onClick={(e) =>
                                  e.stopPropagation()
                                }
              
                                style={{
                                  marginTop: "15px",
              
                                  padding: "15px",
              
                                  backgroundColor: "#f5f5f5",
              
                                  borderRadius: "8px",
              
                                  width: "100%",
              
                                  boxSizing: "border-box"
                                }}
                              >
              
                                <Elements
              
                                  stripe={stripePromise}
              
                                  options={{
                                    clientSecret:
                                      clientSecret,
              
                                    appearance: {
                                      theme: "stripe"
                                    },
                                  }}
                                >
              
                                  <StripePaymentForm
              
                                    clientSecret={
                                      clientSecret
                                    }

                                    price={schoolyeartestsprice}
              
                                    onSuccess={
                                      handlePaymentSuccess
                                    }
              
                                    onCancel={
                                      handlePaymentCancel
                                    }
              
                                  />
              
                                </Elements>
              
                              </div>
              
                            )}
              </div>
        }
     
        {
          (showschoolyearcourses === 'First year' && universityindex >= 0 && collegeindex >= 0) &&
          <>
          {
            universities[universityindex].college[collegeindex].displayfreetext &&
           <label className= 'freeText'>{universities[universityindex].college[collegeindex].freetext }</label>
}
          <SchoolYearCourses courses={universities[universityindex].college[collegeindex].courses.firstyear} scrollreference = {scrollref} />
          </>
        }

      <Row>
        <Col>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
         
          <FormControlLabel  sx={{
                        '& .MuiSvgIcon-root': {
                        fontSize: 20,
                        }, 
                      '& .MuiFormControlLabel-label': {
                        fontWeight: 'bold',
                        }}}
                        value="Second year"  control={<Radio size ="small"/>} label={changeTestLanguage('aitest', 'secondyear')} />
          
            {
              showschoolyearcourses === 'Second year' && !isSchoolYearTestsBought() &&
               <PushButton onClick={handleBuy} label =  {changeTestLanguage('aitest', 'buyalltests')} colorback = {'green'}/>                           
            }
          </div>
        </Col>
      </Row>

       {
        selectedschoolyear === 'Second year' &&
      <div>
       {/* ====================================== */}
            {/* PAYMENT LOADING                         */}
            {/* ====================================== */}

            {showPayment &&
              //buyingItem === item &&
              paymentLoading && (

                <div
                  onClick={(e) =>
                    e.stopPropagation()
                  }

                  style={{
                    padding: "15px",
                    marginTop: "10px",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "8px"
                  }}
                >

                  Creating payment...

                </div>

              )}

               {/* ====================================== */}
                          {/* STRIPE PAYMENT FORM                    */}
                          {/* ====================================== */}
              
                          {showPayment &&
                            //buyingItem === item &&
                            clientSecret && (
              
                              <div
              
                                onClick={(e) =>
                                  e.stopPropagation()
                                }
              
                                style={{
                                  marginTop: "15px",
              
                                  padding: "15px",
              
                                  backgroundColor: "#f5f5f5",
              
                                  borderRadius: "8px",
              
                                  width: "100%",
              
                                  boxSizing: "border-box"
                                }}
                              >
              
                                <Elements
              
                                  stripe={stripePromise}
              
                                  options={{
                                    clientSecret:
                                      clientSecret,
              
                                    appearance: {
                                      theme: "stripe"
                                    },
                                  }}
                                >
              
                                  <StripePaymentForm
              
                                    clientSecret={
                                      clientSecret
                                    }
              
                                    price={schoolyeartestsprice}

                                    onSuccess={
                                      handlePaymentSuccess
                                    }
              
                                    onCancel={
                                      handlePaymentCancel
                                    }
              
                                  />
              
                                </Elements>
              
                              </div>
              
                            )}
              </div>
        }
        {
          (showschoolyearcourses === 'Second year' && universityindex >= 0 && collegeindex >= 0) &&
          <>
          {
            universities[universityindex].college[collegeindex].displayfreetext &&
          <label className= 'freeText'>{universities[universityindex].college[collegeindex].freetext }</label>
          }
           <SchoolYearCourses courses={universities[universityindex].college[collegeindex].courses.secondyear} scrollreference = {scrollref} />
          </>
          }

      <Row>
        <Col>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px'}}>
          
          <FormControlLabel sx={{
                        '& .MuiSvgIcon-root': {
                        fontSize: 20,
                        }, 
                        '& .MuiFormControlLabel-label': {
                          fontWeight: 'bold',
                        }
                      }}
                        value="Third year" control={<Radio size ="small"/>} label={changeTestLanguage('aitest', 'thirdyear')} />
          
              {
              showschoolyearcourses === 'Third year' && !isSchoolYearTestsBought() &&
               <PushButton onClick={handleBuy} label =  {changeTestLanguage('aitest', 'buyalltests')} colorback = {'green'} />                           
              }
          
          </div>              
      </Col>
      </Row>

       {
        selectedschoolyear === 'Third year' &&
      <div>
       {/* ====================================== */}
            {/* PAYMENT LOADING                         */}
            {/* ====================================== */}

            {showPayment &&
              //buyingItem === item &&
              paymentLoading && (

                <div
                  onClick={(e) =>
                    e.stopPropagation()
                  }

                  style={{
                    padding: "15px",
                    marginTop: "10px",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "8px"
                  }}
                >

                  Creating payment...

                </div>

              )}

               {/* ====================================== */}
                          {/* STRIPE PAYMENT FORM                    */}
                          {/* ====================================== */}
              
                          {showPayment &&
                            //buyingItem === item &&
                            clientSecret && (
              
                              <div
              
                                onClick={(e) =>
                                  e.stopPropagation()
                                }
              
                                style={{
                                  marginTop: "15px",
              
                                  padding: "15px",
              
                                  backgroundColor: "#f5f5f5",
              
                                  borderRadius: "8px",
              
                                  width: "100%",
              
                                  boxSizing: "border-box"
                                }}
                              >
              
                                <Elements
              
                                  stripe={stripePromise}
              
                                  options={{
                                    clientSecret:
                                      clientSecret,
              
                                    appearance: {
                                      theme: "stripe"
                                    },
                                  }}
                                >
              
                                  <StripePaymentForm
              
                                    clientSecret={
                                      clientSecret
                                    }
              
                                    price={schoolyeartestsprice}

                                    onSuccess={
                                      handlePaymentSuccess
                                    }
              
                                    onCancel={
                                      handlePaymentCancel
                                    }
              
                                  />
              
                                </Elements>
              
                              </div>
              
                            )}
              </div>
        }

        {
          (showschoolyearcourses === 'Third year' && universityindex >= 0 && collegeindex >= 0) &&
          <>
          {
            universities[universityindex].college[collegeindex].displayfreetext &&
          <label className= 'freeText'>{universities[universityindex].college[collegeindex].freetext }</label>
          }
           <SchoolYearCourses courses={universities[universityindex].college[collegeindex].courses.thirdyear} scrollreference = {scrollref} />
          </>
        }

        {/* fourth year */}
        {
          
          universityindex >= 0 &&
          collegeindex >= 0 &&
          universities[universityindex]?.college?.[collegeindex]?.yearsofstudy >= 4 ?
        
          <>
        <Row>
        <Col>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px'}}>
        
          <FormControlLabel sx={{
                        '& .MuiSvgIcon-root': {
                        fontSize: 20,
                        }, 
                        '& .MuiFormControlLabel-label': {
                          fontWeight: 'bold',
                        }
                      }}
                        value="Fourth year" control={<Radio size ="small"/>} label={changeTestLanguage('aitest', 'fourthyear')} />
          
              {
              showschoolyearcourses === 'Fourth year' && !isSchoolYearTestsBought() &&
               <PushButton onClick={handleBuy} label =  {changeTestLanguage('aitest', 'buyalltests')} colorback = {'green'}/>                           
              }
          </div>              
      </Col>
      </Row>

       {
        selectedschoolyear === 'Fourth year' &&
      <div>
       {/* ====================================== */}
            {/* PAYMENT LOADING                         */}
            {/* ====================================== */}

            {showPayment &&
              //buyingItem === item &&
              paymentLoading && (

                <div
                  onClick={(e) =>
                    e.stopPropagation()
                  }

                  style={{
                    padding: "15px",
                    marginTop: "10px",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "8px"
                  }}
                >

                  Creating payment...

                </div>

              )}

               {/* ====================================== */}
                          {/* STRIPE PAYMENT FORM                    */}
                          {/* ====================================== */}
              
                          {showPayment &&
                            //buyingItem === item &&
                            clientSecret && (
              
                              <div
              
                                onClick={(e) =>
                                  e.stopPropagation()
                                }
              
                                style={{
                                  marginTop: "15px",
              
                                  padding: "15px",
              
                                  backgroundColor: "#f5f5f5",
              
                                  borderRadius: "8px",
              
                                  width: "100%",
              
                                  boxSizing: "border-box"
                                }}
                              >
              
                                <Elements
              
                                  stripe={stripePromise}
              
                                  options={{
                                    clientSecret:
                                      clientSecret,
              
                                    appearance: {
                                      theme: "stripe"
                                    },
                                  }}
                                >
              
                                  <StripePaymentForm
              
                                    clientSecret={
                                      clientSecret
                                    }

                                    price={schoolyeartestsprice}
              
                                    onSuccess={
                                      handlePaymentSuccess
                                    }
              
                                    onCancel={
                                      handlePaymentCancel
                                    }
              
                                  />
              
                                </Elements>
              
                              </div>
              
                            )}
              </div>
        }

        {
          (showschoolyearcourses === 'Fourth year' && universityindex >= 0 && collegeindex >= 0) &&
          <>
            {
            universities[universityindex].college[collegeindex].displayfreetext &&
          <label className= 'freeText'>{universities[universityindex].college[collegeindex].freetext }</label>
          }
           <SchoolYearCourses courses={universities[universityindex].college[collegeindex].courses.fourthyear} scrollreference = {scrollref} />
          </>
        }
        </>
        :
        null
      }

        {/* fifth year */}
        {
          universityindex >= 0 &&
          collegeindex >= 0 &&
          universities[universityindex]?.college?.[collegeindex]?.yearsofstudy >= 5 ?
          <>
        <Row>
        <Col>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px'}}>
         
          <FormControlLabel sx={{
                        '& .MuiSvgIcon-root': {
                        fontSize: 20,
                        }, 
                        '& .MuiFormControlLabel-label': {
                          fontWeight: 'bold',
                        }
                      }}
                        value="Fifth year" control={<Radio size ="small"/>} label={changeTestLanguage('aitest', 'fifthyear')} />
          
               {
              showschoolyearcourses === 'Fifth year' && !isSchoolYearTestsBought() &&
               <PushButton onClick={handleBuy} label =  {changeTestLanguage('aitest', 'buyalltests')} colorback = {'green'}/>                           
                }
          </div>              
      </Col>
      </Row>

 {
        selectedschoolyear === 'Fifth year' &&
      <div>
       {/* ====================================== */}
            {/* PAYMENT LOADING                         */}
            {/* ====================================== */}

            {showPayment &&
              //buyingItem === item &&
              paymentLoading && (

                <div
                  onClick={(e) =>
                    e.stopPropagation()
                  }

                  style={{
                    padding: "15px",
                    marginTop: "10px",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "8px"
                  }}
                >

                  Creating payment...

                </div>

              )}

               {/* ====================================== */}
                          {/* STRIPE PAYMENT FORM                    */}
                          {/* ====================================== */}
              
                          {showPayment &&
                            //buyingItem === item &&
                            clientSecret && (
              
                              <div
              
                                onClick={(e) =>
                                  e.stopPropagation()
                                }
              
                                style={{
                                  marginTop: "15px",
              
                                  padding: "15px",
              
                                  backgroundColor: "#f5f5f5",
              
                                  borderRadius: "8px",
              
                                  width: "100%",
              
                                  boxSizing: "border-box"
                                }}
                              >
              
                                <Elements
              
                                  stripe={stripePromise}
              
                                  options={{
                                    clientSecret:
                                      clientSecret,
              
                                    appearance: {
                                      theme: "stripe"
                                    },
                                  }}
                                >
              
                                  <StripePaymentForm
              
                                    clientSecret={
                                      clientSecret
                                    }

                                    price={schoolyeartestsprice}

              
                                    onSuccess={
                                      handlePaymentSuccess
                                    }
              
                                    onCancel={
                                      handlePaymentCancel
                                    }
              
                                  />
              
                                </Elements>
              
                              </div>
              
                            )}
              </div>
        }
        {
          (showschoolyearcourses === 'Fifth year' && universityindex >= 0 && collegeindex >= 0) &&
           <>  
             {
            universities[universityindex].college[collegeindex].displayfreetext &&
          <label className= 'freeText'>{universities[universityindex].college[collegeindex].freetext }</label>
          }
             <SchoolYearCourses courses={universities[universityindex].college[collegeindex].courses.fifthyear} scrollreference = {scrollref} />
          </>
        }
        </>
        :
        null
      }

       {/*sixth year */}
        {
          universityindex >= 0 &&
          collegeindex >= 0 &&
          universities[universityindex]?.college?.[collegeindex]?.yearsofstudy >= 6 ?
          <>
        <Row>
        <Col>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px'}}>
         
          <FormControlLabel sx={{
                        '& .MuiSvgIcon-root': {
                        fontSize: 20,
                        }, 
                        '& .MuiFormControlLabel-label': {
                          fontWeight: 'bold',
                        }
                      }}
                        value="Sixth year" control={<Radio size ="small"/>} label={changeTestLanguage('aitest', 'sixthyear')} />
          
              {
              showschoolyearcourses === 'Sixth year' && !isSchoolYearTestsBought() &&
               <PushButton onClick={handleBuy} label =  {changeTestLanguage('aitest', 'buyalltests')} colorback = {'green'}/>                           
              }
          </div>              
      </Col>
      </Row>

       {
        selectedschoolyear === 'Sixth year' &&
      <div>
       {/* ====================================== */}
            {/* PAYMENT LOADING                         */}
            {/* ====================================== */}

            {showPayment &&
              //buyingItem === item &&
              paymentLoading && (

                <div
                  onClick={(e) =>
                    e.stopPropagation()
                  }

                  style={{
                    padding: "15px",
                    marginTop: "10px",
                    backgroundColor: "#f5f5f5",
                    borderRadius: "8px"
                  }}
                >

                  Creating payment...

                </div>

              )}

               {/* ====================================== */}
                          {/* STRIPE PAYMENT FORM                    */}
                          {/* ====================================== */}
              
                          {showPayment &&
                            //buyingItem === item &&
                            clientSecret && (
              
                              <div
              
                                onClick={(e) =>
                                  e.stopPropagation()
                                }
              
                                style={{
                                  marginTop: "15px",
              
                                  padding: "15px",
              
                                  backgroundColor: "#f5f5f5",
              
                                  borderRadius: "8px",
              
                                  width: "100%",
              
                                  boxSizing: "border-box"
                                }}
                              >
              
                                <Elements
              
                                  stripe={stripePromise}
              
                                  options={{
                                    clientSecret:
                                      clientSecret,
              
                                    appearance: {
                                      theme: "stripe"
                                    },
                                  }}
                                >
              
                                  <StripePaymentForm
              
                                    clientSecret={
                                      clientSecret
                                    }

                                    price={schoolyeartestsprice}
              
                                    onSuccess={
                                      handlePaymentSuccess
                                    }
              
                                    onCancel={
                                      handlePaymentCancel
                                    }
              
                                  />
              
                                </Elements>
              
                              </div>
              
                            )}
              </div>
        }

        {
          (showschoolyearcourses === 'Sixth year' && universityindex >= 0 && collegeindex >= 0) &&
          <>
           {
            universities[universityindex].college[collegeindex].displayfreetext &&
          <label className= 'freeText'>{universities[universityindex].college[collegeindex].freetext }</label>
          }
           <SchoolYearCourses courses={universities[universityindex].college[collegeindex].courses.sixthyear} scrollreference = {scrollref} />
          </>
        }
        </>
        :
        null
      }

      </div>

      </RadioGroup>
     
    </FormControl>
  );
}

RadioButtonsSchoolYear.defaultProps = {
 
}

export default RadioButtonsSchoolYear
